import customerListEn from "./customer-list/en";
import customerPurchasesEn from "./customer-purchases/en";
import debtPaymentEn from "./debt-payment/en";
import debtReportEn from "./debt-report/en";
import type customerId from "./id";

const customerEn: typeof customerId = {
	customer: {
		title: "Customer",
		subtitle: "Customer management and reports",
		...customerListEn,
		...customerPurchasesEn,
		...debtPaymentEn,
		...debtReportEn,
	},
};

export default customerEn;
